/**
 * Get the authorized fetch function, using hooks
 */

import { useNavigate } from 'react-router-dom';
import { AuthorizationService } from './authorization.service';

const useFetch = () => {
	const nav = useNavigate();
	const authFetch = async (
		input: RequestInfo,
		init?: RequestInit | undefined
	): Promise<Response> => {
		let token;
		try {
			token = AuthorizationService.getAuthorization();
		} catch (e) {
			// No token found, redirect to login
			nav('/login');
			return Response.error();
		}

		if (!token) {
			// No token found, redirect to login
			nav('/login');
			return Response.error();
		}

		// Check expiration. If will expire in less than 5 minutes, renew it
		const now = new Date();
		const expires = new Date(token.expiration || 0);
		if (now.getTime() > expires.getTime() - 5 * 60 * 1000) {
			// Token will expire in less than 5 minutes, renew it
			token = await AuthorizationService.renew();
		}

		// Check if token is expired, if so, redirect to login
		if (now.getTime() > expires.getTime()) {
			// Token expired, redirect to login
			nav('/login');
			return Response.error();
		}

		try {
			const response = await fetch(input, {
				...init,
				headers: {
					'Content-Type': 'application/json',
					Authorization: `Bearer ${token.access_token}`,
					...init?.headers,
				},
			});

			return response;
		} catch (error) {
			console.error('Error fetching data', error);
			return Response.error();
		}
	};

	return authFetch;
};

export default useFetch;
